import ButtonComponent from '@/modules/core/components/shared/Button/ButtonComponent'

export default ButtonComponent
